import {InformationTypeEnum} from '../../enums/information-type.enum';

export class BaseActionDto {
  "caseId": string;
  "documentId": string;
  "externalActionId": string;
  "actionType": InformationTypeEnum;
  "completedDate": Date;
  "approvedDate": Date;
  "rejectedDate": Date;
  "expiredDate": Date;
  "personalMessageId": string;
  "collaboratorUserId": string;

  constructor(data: any) {
    this.caseId = data.caseId;
    this.documentId = data.documentId;
    this.externalActionId = data.externalActionId;
    this.actionType = data.actionType;
    this.completedDate = data.completedDate;
    this.approvedDate = data.approvedDate;
    this.rejectedDate = data.rejectedDate;
    this.expiredDate = data.expiredDate;
    this.personalMessageId = data.personalMessageId;
    this.collaboratorUserId = data.collaboratorUserId;
  }
}
